export const selectShowMenu = state => state.dashboard.show
export const selectMenuCollapsed = state => state.dashboard.collapsed
export const selectMenuSelected = state => state.dashboard.selected
export const selectSearchShow = state => state.dashboard.searchShow
export const selectMenuRoutes = state => state.dashboard.routes
export const selectMenuGroup = state => state.dashboard.group
